require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-basic-html-and-html-5-use-html-5-to-require-a-field.json") })
        }
      }, "path---responsive-web-design-basic-html-and-html-5-use-html-5-to-require-a-field");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-basic-html-and-html-5-use-html-5-to-require-a-field!./.cache/json/responsive-web-design-basic-html-and-html-5-use-html-5-to-require-a-field.json
// module id = 2656
// module chunks = 231608221292675